import React from 'react';
import { includes } from 'lodash';
import cx from 'classnames';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import WidgetItemListWrap from '../../WidgetItemListWrap';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import { WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/widget/models';
import {
  SEARCH_STORE_LIST_TABLE_EMPTY_TEXT,
  SELECTED_SEARCH_STORE_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/widgetConstants';
import { columns } from './columns';
import './SearchStoreListModal.scss';

const SearchStoreListModal = (props) => {
  const {
    isOpen,
    closeModal,
    onSubmit,
    getStoreList,
    data,
    onCheckStore,
    selectedStoreList,
    selectedStoreIdList,
    openImgViewModal,
  } = props;
  const { listData, linkType } = data;
  const { list, filterOption, pagination, summary = {} } = listData;

  return (
    <Modal
      title="브랜드 검색"
      isOpen={isOpen}
      width={760}
      height={650}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-store-list-modal">
        <WidgetItemListWrap title="선택된 브랜드">
          <Table
            className="selected-store-list-table"
            emptyText={SELECTED_SEARCH_STORE_LIST_TABLE_EMPTY_TEXT}
            data={selectedStoreList}
            sortable={false}
            defaultPageSize={1}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedStoreIdList}
            onCheck={(list) => onCheckStore(list)}
            columns={() =>
              columns({
                openImgViewModal,
              })
            }
          />
        </WidgetItemListWrap>

        <WidgetItemListWrap title="브랜드 리스트">
          <TableWithSummary
            className="store-list-table"
            totalCnt={summary.totalCnt}
            emptyText={SEARCH_STORE_LIST_TABLE_EMPTY_TEXT}
            initialOption={{
              filterOption: WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL[linkType],
            }}
            data={list}
            maxHeight={380}
            showPagination
            filterOption={filterOption}
            pagination={pagination}
            getList={getStoreList}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedStoreIdList}
            onCheck={(list) => onCheckStore(list)}
            columns={(utils) =>
              columns({
                openImgViewModal,
                ...utils,
              })
            }
            getTdProps={(state, rowInfo) => {
              return {
                className: cx({ selected: includes(selectedStoreIdList, rowInfo.original.id) }),
              };
            }}
          />
        </WidgetItemListWrap>
      </div>
    </Modal>
  );
};

export default SearchStoreListModal;
